import { useField } from 'formik';

import { addWithConfig } from '../../utils';
import { useFormikFormControlLabel, usePropsWithFormikFormControlName } from '../formik-form-control';
import { Input } from '../input';

import type { FormikInputProps } from './types';

export const FormikInput = (props: FormikInputProps) => {
  const { name, inputProps, ...rest } = usePropsWithFormikFormControlName(props);
  const formControlLabel = useFormikFormControlLabel();
  const [field, meta, helpers] = useField(name);
  const isInvalid = Boolean(meta.error && meta.touched);
  const resolvedAccessibilityLabel =
    inputProps?.accessibilityLabel ?? props.label ?? formControlLabel;
  return (
    <Input
      isInvalid={Boolean(isInvalid)}
      value={field.value}
      {...inputProps}
      {...rest}
      accessibilityLabel={resolvedAccessibilityLabel}
      onChangeText={(nextText) => {
        helpers.setValue(nextText);
      }}
      onBlur={() => {
        helpers.setTouched(true);
      }}
    />
  );
};

export default addWithConfig(FormikInput);
